import * as React from "react";

function ExclamationTriangleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "ExclamationTriangleOutline-ExclamationTriangleOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ExclamationTriangleOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ExclamationTriangleOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4232976,5.01280751 C26.0290095,5.35966735 26.5307215,5.8639161 26.8758363,6.47269051 L43.9897723,36.6612652 C45.0521651,38.5353008 44.4018414,40.9201009 42.5372336,41.9878653 C41.9511231,42.3235005 41.2881721,42.5 40.6136012,42.5 L6.38572933,42.5 C4.23970028,42.5 2.5,40.7515035 2.5,38.5946238 C2.5,37.9166421 2.6756116,37.2503391 3.00955827,36.6612652 L20.1234942,6.47269051 C21.185887,4.59865494 23.5586898,3.94504306 25.4232976,5.01280751 Z M22.7183146,7.89574441 L22.6566056,7.99100253 L5.55751165,38.0467393 C5.47409738,38.1933598 5.43023256,38.3592025 5.43023256,38.5279521 C5.43023256,39.0264531 5.80491925,39.4373099 6.28763114,39.4934603 L6.40082242,39.5 L40.5990104,39.5 C40.7675068,39.5 40.9331008,39.4560693 41.0795014,39.3725297 C41.5119814,39.1257465 41.6829358,38.5963108 41.492683,38.1484724 L41.4423211,38.0467393 L24.3432272,7.99100253 C24.2570233,7.83947862 24.131704,7.71397114 23.9804074,7.62763775 C23.5479274,7.38085458 23.0059953,7.50350061 22.7183146,7.89574441 Z M24.9651163,32.9 L24.9651163,35.1 C24.9651163,35.3209139 24.7860302,35.5 24.5651163,35.5 L22.4348837,35.5 C22.2139698,35.5 22.0348837,35.3209139 22.0348837,35.1 L22.0348837,32.9 C22.0348837,32.6790861 22.2139698,32.5 22.4348837,32.5 L24.5651163,32.5 C24.7860302,32.5 24.9651163,32.6790861 24.9651163,32.9 Z M24.9651163,18.9 L24.9651163,29.1 C24.9651163,29.3209139 24.7860302,29.5 24.5651163,29.5 L22.4348837,29.5 C22.2139698,29.5 22.0348837,29.3209139 22.0348837,29.1 L22.0348837,18.9 C22.0348837,18.6790861 22.2139698,18.5 22.4348837,18.5 L24.5651163,18.5 C24.7860302,18.5 24.9651163,18.6790861 24.9651163,18.9 Z",
    id: "ExclamationTriangleOutline-\u5F62\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default ExclamationTriangleOutline;